<template>
  <nav class="navbar navbar-default">
    <div class="container">
      <div class="navbar-header">

        <!-- Collapsed Hamburger -->
        <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#app-navbar-collapse">
          <span class="sr-only">Vis meny</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>

        <a class="navbar-brand" href="#">
          <ul class="headermenu">
            <router-link tag="li" :to="{ name: 'dashboard.index' }" exact>
              <a>Helt Opplagt</a>
            </router-link>
            <li><i class="fa fa-phone" aria-hidden="true"></i> <a href="tel:02346"> 0 23 46</a></li>
            <li>
              <cc-spinner></cc-spinner>
            </li>
          </ul>
        </a>
      </div> <!-- /navbar-header -->

      <div class="collapse navbar-collapse" id="app-navbar-collapse">
        <!-- Left Side Of Navbar -->
        <ul class="nav navbar-nav">
            &nbsp;
        </ul>

        <!-- Right Side Of Navbar -->
        <ul class="nav navbar-nav navbar-right">

          <router-link tag="li" :to="{ name: 'contractlist' }" exact v-if="hasModuleContracts">
            <a>Nettmeny</a>
          </router-link>

          <router-link tag="li" :to="{ name: 'catering' }" exact v-if="hasModuleCatering">
            <a>Catering</a>
          </router-link>

          <li class="dropdown">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false">
              {{ currentUser.name }} {{ currentUser.customernumber }} <span class="caret"></span>
            </a>

            <ul class="dropdown-menu" role="menu">
              <template v-if="isAdmin">
                <li>
                  <router-link :to="{name:'admin'}">
                    <i class="fa fa-cog" aria-hidden="true"></i> Administrasjon
                  </router-link>
                </li>
              </template>
              <li>
                <a href="#" @click="logout">
                  <i class="fa fa-sign-out" aria-hidden="true"></i> Logg ut
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>

    </div>
  </nav>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { version } from '../../config'
  import CcSpinner from '../general/spinner'

  export default {
    components: {
      CcSpinner,
    },

    computed: {
      ...mapGetters(['currentUser', 'isLogged', 'hasModuleContracts', 'hasModuleCatering']),
      version() {
        return version
      },
      isAdmin() {
        return this.currentUser.isadmin === '1'
      }
    },

    watch: {
      isLogged(value) {
        if (value === false) {
          this.$router.push({ name: 'auth.signin' })
        }
      },
    },

    methods: {
      ...mapActions(['logout']),
    },
  }
</script>

<style scoped>
.page__nettmeny { background-color: #0078BE; }
.page__nettmeny a { color: #fff !important; }

.page__catering { background-color: #EC9F49; }

.headermenu {
  list-style: none;
  display: flex;
  margin-left: -60px;
}

.headermenu li {
  padding-left: 15px;
}

.navbar {
  margin-bottom: 0;
}
  .spacer {
    margin-left: 120px;
  }
  .username {
    padding: 6px 20px;
    border-radius: 20px;
    background-color: #ddd;
    display: inline-block;
  }
  .version {
    position: absolute;
    right: 15px;
    top: 58px;
  }
</style>



// WEBPACK FOOTER //
// navbar.vue?c3ddae12